var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisualizar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06199 12.3474C1.97865 12.1229 1.97865 11.8759 2.06199 11.6514C2.87369 9.68324 4.2515 8.00042 6.02076 6.81628C7.79001 5.63214 9.87103 5 12 5C14.1289 5 16.21 5.63214 17.9792 6.81628C19.7485 8.00042 21.1263 9.68324 21.938 11.6514C22.0213 11.8759 22.0213 12.1229 21.938 12.3474C21.1263 14.3155 19.7485 15.9983 17.9792 17.1825C16.21 18.3666 14.1289 18.9988 12 18.9988C9.87103 18.9988 7.79001 18.3666 6.02076 17.1825C4.2515 15.9983 2.87369 14.3155 2.06199 12.3474Z",
    stroke: "#444444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9994C13.6568 14.9994 15 13.6562 15 11.9994C15 10.3425 13.6568 8.99938 12 8.99938C10.3431 8.99938 8.99999 10.3425 8.99999 11.9994C8.99999 13.6562 10.3431 14.9994 12 14.9994Z",
    stroke: "#444444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisualizar);
export default __webpack_public_path__ + "static/media/iconVisualizar.6c471980ee8f8167228d5bac2eb1832f.svg";
export { ForwardRef as ReactComponent };